import { DataCollectionRoom } from '../types';

export const sumRoomsArea = (rooms: { [id: string]: DataCollectionRoom }): number => {
    const sum = Object.values(rooms).reduce((acc, room) => acc + (Number.parseFloat(room.area) || 0), 0);
    return Math.round((Math.abs(sum) + Number.EPSILON) * 100) / 100;
};
